import '../styles/restroCard.css'
import { CLOUDINARY_URL } from '../../utils/constants';

const RestroCard = function (props) {
    const{
        name,
        cloudinaryImageId,
        aggregatedDiscountInfoV3,
        avgRating,
        sla,
        cuisines,
        areaName
    }=props.restroData;
    const offerHeader = aggregatedDiscountInfoV3?.header || "";
    const offerSubHeader = aggregatedDiscountInfoV3?.subHeader || "";
    const imgSrc = cloudinaryImageId ? `${CLOUDINARY_URL}${cloudinaryImageId}` : "https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=660&auto=format&fit=crop";

    return (
        <div className="restro-card">
            <figure>
                <img 
                    src={imgSrc} 
                    alt="restro img" 
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=660&auto=format&fit=crop";
                    }}
                />
                <figcaption>{offerHeader+" "+offerSubHeader}</figcaption>
            </figure>
            <div className="restro-details">
                <h3 className="restro-name">{name}</h3>
                <div className="rating-time">
                    <span className="star-icon">★</span>
                    <span className="rating-text">{`${avgRating} • ${sla?.slaString}`}</span>
                </div>
                <div className="cuisine">{cuisines.join(", ")}</div>
                <div className="location">{areaName}</div>
            </div>
        </div>
    )
};


export const promotedRestroCard = function (RestroCard) {

    return function (props) {
        return (
            <div className='promoted-restro-card'>
                <label htmlFor="">Promoted</label>
                <RestroCard {...props}/>
            </div>
        )       
    }     
}

export default RestroCard;